// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : logging parts
// =============================================================================
// ---Third-party imports
import React from 'react'
import {funcPart} from 'uix/parts'

import {LogStream} from './components'

export const LogConsole = funcPart(
  {partStyle: {flex: 1, display: 'flex', height: '100%', width: '100%'}},
  ({}) => <LogStream as="div" />
)
